import PropTypes from 'prop-types';
import * as React from 'react';

const Edit = React.forwardRef(({ color = 'currentColor', size, strokeWidth = 1.2, ...rest }, ref) => {
  const width = size ?? 21;
  const height = size ?? 21;

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 22 18"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...rest}
    >
      <path d="m14.862 3.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L8.582 15.07a4.5 4.5 0 0 1-1.897 1.13L4 17l.8-2.685a4.5 4.5 0 0 1 1.13-1.897zm0 0L17.5 6.125M16 13v4.75A2.25 2.25 0 0 1 13.75 20H3.25A2.25 2.25 0 0 1 1 17.75V7.25A2.25 2.25 0 0 1 3.25 5H8" />
    </svg>
  );
});

Edit.displayName = 'Edit';

Edit.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default Edit;
